import React, { Component } from 'react'
import ImagePreview from './ImagePreview'
import LinkWithIcon from './LinkWithIcon'
import styled from 'react-emotion'

const Wrapper = styled('div')`
  text-align: center;
  margin: 20px 0;
  label {
    cursor: pointer;
  }
`

export default class TuiFileInput extends Component {
  handleChange = e => {
    const { input: { onChange } } = this.props
    const file = e.target.files[0]
    onChange(file)
    this.refs.fileName.innerHTML = file ? file.name : null
  }
  render() {
    const { input: { value, name }, accept, preview, meta: { touched, error }, title } = this.props
    return (
      <Wrapper>
        {preview && <ImagePreview file={value} />}
        <div ref="fileName" />
        <label htmlFor={name}>
          <LinkWithIcon icon="plus--circled" text={title} />
        </label>
        <input id={name} name={name} style={{ display: 'none' }} type="file" accept={accept} onChange={e => this.handleChange(e)} />
        {touched && error && <span className="validation-message field-validation-error">{error}</span>}
      </Wrapper>
    )
  }
}
